import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    activeSection: "Wardrobe Services",
    activeItem: null,
    activeCardLabel: null,

    showTopPanel: true,
    showGallery: false,
    openInfoSlideGallery: false,
    showInfo: false,
    expanded: false,
    showServices: false,
    showHero: true,
    toggleState: false,
    showTopHero: true,
    showTopService: false,
    showTopHeroBanner: false,
    showTopServiceBanner: false,
    serviceList: false,
    switchServiceList: false,
    listInSide: false,
    sectionBanner: false,
    privateService: false,
    disolveprivateService: false,
    teamsMenu: false,
    isTeamInfoPanel: false,
    selectedTeamMember: null,
    iseditorialLayout: false,
    isIndividualBlog: null,
    isServicePhilosophy: false,
    isFaq: false,
    isContact: false,
    singleFAQ : null,
    issingleFAQ: false,
    serviceData: [],
    isMenuSectionClicked: false,
    teamsData: [],
    faq_data: [],
    contact_data: [],
    blog_data: [],
    singleBlogData: [],
    service_phylosophy_data: [],
    isHeaderFading: false,
    isPanelInfoFading: false,
    isAcceptingFormOpen: false,
    openGallery: false,
};

const serviceSlice = createSlice({
    name: "service",
    initialState,
    reducers: {
        setSection(state, action) {
            state.activeSection = action.payload;
            state.activeItem = null;
            state.activeCardLabel = null;
            state.isServicePhilosophy = false;

            state.showTopPanel = true;
            state.showGallery = false;
            state.openInfoSlideGallery = false;
            state.showInfo = false;
            state.expanded = false;
        },

        openItem(state, action) {
            state.activeItem = action.payload;
            state.activeCardLabel = action.payload.label;

            state.showGallery = true;
            state.showInfo = true;
            state.showTopPanel = false;
            state.expanded = true;
            state.serviceList = false;

        },

        openTopPanel(state) {
            state.showTopPanel = true;
            state.showServices = true;
            state.showHero = false;
            state.showGallery = false;
            state.openInfoSlideGallery = false;
            state.showInfo = false;
            state.expanded = false;
        },

        closeTopPanel(state) {
            state.showTopPanel = false;
            state.showGallery = false;
            state.openInfoSlideGallery = false;
            state.showInfo = false;
            state.isFaq = false;
            state.isContact = false;
            state.expanded = false;
            state.serviceList = true;
            state.showTopHeroBanner = false;
            state.issingleFAQ = false;
        },

        closePanels(state) {
            state.showGallery = false;
            state.openInfoSlideGallery = false;
            state.showInfo = false;
            state.expanded = false;
            state.showTopServiceBanner = false;
            state.showTopHeroBanner = false;
            state.issingleFAQ = false;
        },

        closeGalleryOnly(state) {
            state.openInfoSlideGallery = true;
        },

        showGalleryOnly(state) {
            state.showGallery = true;
            state.openInfoSlideGallery = false;
        },

        showServicesBanner(state) {
            state.showTopServiceBanner = true;
            state.showTopHeroBanner = false;
            state.serviceList = false;
        },

        showHeroBanner(state) {
            state.showTopServiceBanner = false;
            state.showTopHeroBanner = true;
            state.serviceList = false;
            state.switchServiceList = false;
            state.isServicePhilosophy = false;
        },

        toggleHeroService(state) {
            if (!state.showTopServiceBanner && !state.showTopHeroBanner) {
                state.showTopServiceBanner = false;
                state.showTopHeroBanner = true;
            } else {
                // state.showTopServiceBanner = !state.showTopServiceBanner;
                state.showTopServiceBanner = false;
                // state.showTopHeroBanner = !state.showTopHeroBanner;
            }
            state.isContact = false;
            state.sectionBanner = false;
            state.isAcceptingFormOpen = false;
            state.isMenuSectionClicked = false;
            state.isFaq = false;
            state.issingleFAQ = false;
            state.isIndividualBlog = null;
            state.isServicePhilosophy = false;
            state.iseditorialLayout = false;
            state.serviceList = false;
            state.switchServiceList = false;
            // state.privateService = false;
            state.toggleState = !state.toggleState;
            state.showHero = true;
            state.showTopPanel = !state.showTopPanel;

        },
        showServiceList(state) {
            state.serviceList = true;
            state.switchServiceList = false;
            state.isAcceptingFormOpen = false;
            state.listInSide = false;
            state.iseditorialLayout = false;
        },
        hideServiceList(state) {
            state.serviceList = false;
            state.switchServiceList = true;
        },
        showListInSide(state) {
            state.listInSide = true;
            state.isAcceptingFormOpen = false;
            state.serviceList = false;
        },
        showSectionBanner(state) {
            state.sectionBanner = true;
        },
        hideSectionBanner(state) {
            state.sectionBanner = false;
        },
        showPrivateService(state) {
            state.disolveprivateService = false;
            state.privateService = true;
            state.isAcceptingFormOpen = false;
            state.iseditorialLayout = false;
        },
        hidePrivateService(state) {
            state.privateService = false;
        },
        disolvePrivateService(state) {
            state.disolveprivateService = true;
        },
        showTeamsMenu(state) {
            state.teamsMenu = true;
            state.isAcceptingFormOpen = false;
            state.iseditorialLayout = false;
        },
        hideTeamsMenu(state) {
            state.teamsMenu = false;
        },
        showTeamInfoPanel(state) {
            state.isTeamInfoPanel = true;
            state.iseditorialLayout = false;
            state.isAcceptingFormOpen = false;
        },
        hideTeamInfoPanel(state) {
            state.isTeamInfoPanel = false;
        },
        selectMember(state, action) {
            state.selectedTeamMember = action.payload;
        },
        showEditorialLayout(state) {
            state.iseditorialLayout = true;
        },
        hideEditorialLayout(state) {
            state.iseditorialLayout = false;
            state.isIndividualBlog = null;
        },
        showBlog(state, action) {
            state.isIndividualBlog = action.payload;
            state.isAcceptingFormOpen = false;
        },
        hideBlog(state) {
            state.isIndividualBlog = null;
        },
        showServicePhilosophy(state) {
            state.isServicePhilosophy = true;
        },
        hideServicePhilosophy(state) {
            state.isServicePhilosophy = false;
        },
        showFaq(state) {
            state.isFaq = true;
            state.isAcceptingFormOpen = false;
        },
        hideFaq(state) {
            state.isFaq = false;
        },
        showContact(state) {
            state.isContact = true;
            state.isAcceptingFormOpen = false;
        },
        hideContact(state) {
            state.isContact = false;
        },
        showSingleFAQ(state, action){
            state.singleFAQ = action.payload
            state.isAcceptingFormOpen = false;
            state.issingleFAQ = true;
        },
        hideSingleFAQ(state){
            state.issingleFAQ = false;
        },
        setServiceData(state, action){
            state.serviceData = action.payload;
        },
        collapseContentSection(state){
            state.isMenuSectionClicked = true;
        },
        showContentSection(state){
            state.isMenuSectionClicked = false;
        },
        setTeamsData(state, action){
            state.teamsData = action.payload;
        },
        setfaqData(state, action){
            state.faq_data = action.payload;
        },
        setContactData(state, action){
            state.contact_data = action.payload;
        },
        setPhylosophyData(state, action){
            state.service_phylosophy_data = action.payload;
        },
        setBlogData(state, action){
            state.blog_data = action.payload;
        },
        setSingleBlogData(state, action){
            state.singleBlogData = action.payload;
        },
        startHeaderFade(state) {
            state.isHeaderFading = true;
        },
        endHeaderFade(state) {
            state.isHeaderFading = false;
        },
        startPanelInfoFade(state) {
            state.isPanelInfoFading = true;
        },
        endPanelInfoFade(state) {
            state.isPanelInfoFading = false;
        },
        showAcceptingForm(state) {
            state.isAcceptingFormOpen = true;
        },
        hideAcceptingForm(state) {
            state.isAcceptingFormOpen = false;
        },
        showMainMenu(state) {
            state.showTopServiceBanner = false;
            state.showTopHeroBanner = false;
            state.isContact = false;
            state.isAcceptingFormOpen = false;
            state.isMenuSectionClicked = false;
            state.isFaq = false;
            state.issingleFAQ = false;
            state.isIndividualBlog = null;
            state.isServicePhilosophy = false;
            state.iseditorialLayout = false;
            state.serviceList = false;
            state.switchServiceList = false;
            state.privateService = false;
            // state.toggleState = !state.toggleState;
            state.showHero = true;
            state.showTopPanel = !state.showTopPanel;
        },
        openGalleryOfService(state) {
            state.openGallery = true;
        },
        closeGalleryOfService(state) {
            state.openGallery = false;
        }






    }
});

export const {
    setSection,
    openItem,
    closePanels,
    openTopPanel,
    closeGalleryOnly,
    showGalleryOnly,
    closeTopPanel,
    showHeroBanner,
    showServicesBanner,
    toggleHeroService,
    showServiceList,
    hideServiceList,
    showListInSide,
    showSectionBanner,
    hideSectionBanner,
    showPrivateService,
    hidePrivateService,
    disolvePrivateService,
    showTeamsMenu,
    hideTeamsMenu,
    showTeamInfoPanel,
    hideTeamInfoPanel,
    selectMember,
    showEditorialLayout,
    hideEditorialLayout,
    showBlog,
    hideBlog,
    showServicePhilosophy,
    hideServicePhilosophy,
    showFaq,
    hideFaq,
    showContact,
    hideContact,
    showSingleFAQ,
    hideSingleFAQ,
    setServiceData,
    collapseContentSection,
    showContentSection,
    setTeamsData,
    setfaqData,
    setContactData,
    setPhylosophyData,
    setBlogData,
    setSingleBlogData,
    startHeaderFade,
    endHeaderFade,
    startPanelInfoFade,
    endPanelInfoFade,
    showAcceptingForm,
    hideAcceptingForm,
    showMainMenu,
    openGalleryOfService,
    closeGalleryOfService
} = serviceSlice.actions;

export default serviceSlice.reducer;
